import Axios from 'axios'
import React, { Component } from 'react'
import Topbar from '../../Common/Topbar'
import RoundCard from '../../Components/RoundCard'
import Spinner from '../../Components/Spinner'
import config from '../../Shared/config'
import './TeacherProfile.scss'

export default class TeacherProfile extends Component {

    constructor(props) {
        super(props)

        this.state = {
            teacherData: {},
            teacherFetched: false,
            teacherloading: true
        }
    }

    componentDidMount() {
        const id = this.props?.match?.params?.id
        this.getTeacherInfo(id).then(res => {
            if (res) {
                this.setState({
                    teacherData: res,
                    teacherFetched: true,
                    teacherloading: false
                })
            } else {
                this.setState({
                    teacherData: {},
                    teacherFetched: false,
                    teacherloading: false
                })
            }
        }).catch(err => {
            console.error(err)
            this.setState({
                teacherData: {},
                teacherFetched: false,
                teacherloading: false
            })
        })
    }

    getTeacherInfo = async (id) => {
        this.setState({
            teacherFetched: false,
            teacherloading: true
        })
        const url = `${config.apiUrl}/Teacher/getone?id=${id}`;
        return Axios.get(url).then(res => {
            if (!res?.data?.error) {
                return res.data.data
            }
        })
    }

    render() {
        const { 'teacherData': teacher, teacherFetched, teacherloading } = this.state

        return (
            <div className='teacher-profile-container'>
                <Topbar type={'fixedover'} theme={'solid'} />
                <div className="below-topbar-content">
                    {
                        teacherloading ? (
                            <Spinner />
                        ) : (
                                teacherFetched ? (
                                    <div className="teacher-one">
                                        <main>
                                            <div style={{ backgroundImage: `url(${teacher.profileImageUrl})` }} className="profile-picture"></div>
                                            <div className="info">
                                                <div className="name">{teacher.firstName || ''} {' '} {teacher.lastName || ''}</div>
                                                <div className="username"> {'@' + teacher.userName}</div>
                                                <div className="experience">
                                                    <div className="experience-type">
                                                        <div className="experience-label">Teaching Experience</div>
                                                        <div className="experience-value">{teacher.teachingExperience}</div>
                                                    </div>
                                                    <div className="experience-type">
                                                        <div className="experience-label">Practical Experience</div>
                                                        <div className="experience-value">{teacher.practiceExperience}</div>
                                                    </div>
                                                    <div className="experience-type">
                                                        <div className="experience-label">Number of Students Taught</div>
                                                        <div className="experience-value">{teacher.numberOfStudentsTaught}</div>
                                                    </div>
                                                </div>
                                                <div className="characteristics">
                                                    {
                                                        teacher.teacherCharacteristics.map((item, idx) => (
                                                            <div className="pill">{item}</div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </main>
                                        <RoundCard scaleOnHover={false} className='description'>
                                            <h3>Description</h3>
                                            {
                                                teacher.description
                                            }
                                        </RoundCard>
                                    </div>
                                ) : (
                                        null
                                    )
                            )
                    }
                </div>
            </div>
        )
    }
}
